import styled from "styled-components";

interface IProps {
    titleReward?: string;
    totleReward?: string;
    textButton?: string;
    imgReward?: string;
}

export const RewardSpin = (props: IProps) => {
    return (
        <StyledRewardSpin>
            <div className="img-main-reward">
                <img src={props.imgReward || "../../images/img-discount.svg"} alt="" />
            </div>
            <div className="title-main-reward">{props.titleReward || "Robinhood 20% Off"}</div>
            <div className="total-main-reward">{props.totleReward || "x3 Coupons"}</div>
            <StyledBtnSpinMission>
                {props.textButton || "See Reward"}
            </StyledBtnSpinMission>
        </StyledRewardSpin>
    );
};

const StyledBtnSpinMission = styled.button`
    font-size: 13px;
    line-height: 15px;
    font-weight: 600;
    padding: 15px 12px;
    border-radius: 12px;
    width: 100%;
    background-color: #ffe212;
    color: #000;
    border: none;
`;

const StyledRewardSpin = styled.div`
    position: relative;
    margin-bottom: 10px;
    .img-main-reward {
        width: 100%;
        margin-bottom: 10px;
        img {
            width: 100%;
            height: auto;
        }
    }
    .title-main-reward {
        font-size: 18px;
        line-height: 21px;
        font-weight: 600;
        color: #000;
        margin-bottom: 10px;
        text-align: center;
    }
    .total-main-reward {
        font-size: 14px;
        line-height: 20px;
        color: #E53223;
        margin-bottom: 10px;
        text-align: center;
    }
`;